import {
  images,
  scrolling,
} from 'assets/utilities';

import './page.scss';

const destroy = function destroyPage() {
};

const init = function initPage() {
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();
};

export default {
  destroy,
  init,
};
